export enum NotificationStatus {
  DRAFT,
  ACTIVE,
  CLOSED,
}

export enum NotificationPeriodicity {
  DAILY,
  WEEKLY,
  BIWEEKLY,
  MONTHLY,
  CUSTOM,
}
